var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/report") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4,3.81818182 C4,3.57707592 4.09365052,3.34584509 4.26034953,3.17535747 C4.455529,2.9757421 4.80665341,2.73633909 5.33654162,2.51956664 C6.13904436,2.19127007 7.16765229,2 8.44444444,2 C9.70361192,2 10.5623377,2.25092636 12.330125,2.9741121 C13.895671,3.61456272 14.5925008,3.81818182 15.5555556,3.81818182 C16.6120967,3.81818182 17.4168221,3.6685428 18.0032083,3.42865755 C18.3066534,3.30452091 18.455529,3.20301483 18.4825718,3.17535747 C19.0425405,2.60266214 20,3.00826832 20,3.81818182 L20,14.7272727 C20,14.9683786 19.9063495,15.1996095 19.7396505,15.3700971 C19.544471,15.5697124 19.1933466,15.8091155 18.6634584,16.0258879 C17.8609556,16.3541845 16.8323477,16.5454545 15.5555556,16.5454545 C14.2963881,16.5454545 13.4376623,16.2945282 11.669875,15.5713424 C10.104329,14.9308918 9.40749919,14.7272727 8.44444444,14.7272727 C7.38790327,14.7272727 6.58317786,14.8769118 5.99679171,15.116797 C5.91132774,15.1517595 5.83812487,15.1849269 5.77645173,15.2151549 L5.77777778,21.0909091 C5.77777778,21.5929861 5.37980867,22 4.88888889,22 C4.39796911,22 4,21.5929861 4,21.0909091 L4,3.81818182 Z M8.44444444,3.81818182 C7.38790327,3.81818182 6.58317786,3.96782084 5.99679171,4.20770608 C5.92093043,4.23874024 5.85472975,4.26835999 5.79767815,4.29576505 L5.77777778,4.30545455 L5.77777778,13.2690909 L5.98115838,13.2089751 C6.59244857,13.0380464 7.30668317,12.9340454 8.13040413,12.9130443 L8.44444444,12.9090909 C9.70361192,12.9090909 10.5623377,13.1600173 12.330125,13.883203 C13.895671,14.5236536 14.5925008,14.7272727 15.5555556,14.7272727 C16.6120967,14.7272727 17.4168221,14.5776337 18.0032083,14.3377485 C18.0790696,14.3067143 18.1452703,14.2770946 18.2023219,14.2496895 L18.2222222,14.2390909 L18.2222222,5.27545455 L18.0188416,5.3364794 C17.4075514,5.50740813 16.6933168,5.61140913 15.8695959,5.63241023 L15.5555556,5.63636364 C14.2963881,5.63636364 13.4376623,5.38543728 11.669875,4.66225154 C10.104329,4.02180092 9.40749919,3.81818182 8.44444444,3.81818182 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/report",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.7997afdfd925ceacb27fa6617d1e8a85.svg";
export { ForwardRef as ReactComponent };